import React, { useEffect, useRef, useState } from 'react';

const colors = [
  '#F44336',
  '#E91E63',
  '#9C27B0',
  '#3F51B5',
  '#03A9F4',
  '#009688',
  '#4CAF50',
  '#FF9800',
  '#795548',
];

function getAvatarName(fullName) {
  if (!fullName) return '';
  const words = fullName.trim().split(/\s+/);
  const first = words[0]?.[0] || '';
  const last = words[words.length - 1]?.[0] || '';
  return (first + last).toUpperCase();
}

function getRandomColor(name) {
  if (!name) return colors[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
}

const Avatar = ({ fullName, isCircle }) => {
  const safeName = fullName || 'U N';
  const avatarText = getAvatarName(safeName);
  const bgColor = getRandomColor(safeName);

  const avatarRef = useRef(null);
  const [fontSize, setFontSize] = useState(20);

  useEffect(() => {
    if (avatarRef.current) {
      const height = avatarRef.current.offsetHeight;
      setFontSize(height - height / 3);
    }
  }, []);
  return (
    <div
      ref={avatarRef}
      style={{
        width: '100%',
        height: isCircle ? 'auto' : '100px',
        aspectRatio: isCircle ? '1 / 1' : undefined,
        borderRadius: isCircle ? '50%' : '4px',
        backgroundColor: bgColor,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: fontSize,
        overflow: 'hidden',
        textAlign: 'center',
        flexShrink: 0,
      }}
    >
      {avatarText}
    </div>
  );
};

export default Avatar;
